(() => {
  if (window.usfBlankCartInstalled) return;
  window.usfBlankCartInstalled = true;
  const cache = new Map();
  const forms = () => [...document.querySelectorAll('form[action*="/cart/add"]')].filter(f => !f.closest('#usf-custom-studio') && entry(f));
  const entry = f => f.closest('.product-form-wrapper')?.querySelector('[data-usf-pro-entry]');
  const labels = f => JSON.parse(entry(f).querySelector('[data-usf-cart-labels]').textContent);
  const id = f => f.querySelector('[name="id"]')?.value;
  const status = (f, text) => { entry(f).querySelector('[data-usf-cart-status]').textContent = text; };
  async function read(f, params) {
    const url = new URL(entry(f).dataset.productUrl, location.origin);
    url.searchParams.set('section_id', 'usastarfashion-cart-variant');
    for (const [key, value] of Object.entries(params)) url.searchParams.set(key, value);
    const key = url.href;
    if (!cache.has(key)) cache.set(key, (async () => {
      const response = await fetch(key, {credentials:'same-origin'});
      if (!response.ok) throw new Error('Variant unavailable');
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const data = doc.querySelector('[data-usf-cart-variant]');
      if (!data) throw new Error('Variant unavailable');
      return JSON.parse(data.textContent);
    })().catch(error => { cache.delete(key); throw error; }));
    return cache.get(key);
  }
  async function resolve(f, selected) {
    const current = await read(f, {variant:selected});
    if (!current.variant || String(current.variant.id) !== String(selected)) throw new Error('Select a colour and size');
    const method = current.options.findIndex(o => o.name === 'Personalisation Type');
    if (method < 0) throw new Error('Blank unavailable');
    const blank = current.options[method].values.find(v => v.name.toLowerCase() === 'blank');
    const values = current.options.map((o, n) => n === method ? blank : o.values.find(v => v.selected));
    if (values.some(v => !v?.id)) throw new Error('Blank unavailable');
    const result = await read(f, {option_values:values.map(v => v.id).join(',')});
    const v = result.variant;
    if (!v || !v.available || v.options.some((value,n) => value !== (n === method ? blank.name : current.variant.options[n]))) throw new Error('Blank unavailable');
    return v;
  }
  function paint(f, text, disabled) {
    for (const button of f.querySelectorAll('button[name="add"]')) {
      const target = button.querySelector('.btn-text') || button;
      if (target.textContent !== text) target.textContent = text;
      if (button.disabled !== disabled) button.disabled = disabled;
      button.setAttribute('aria-label', text);
    }
  }
  async function update(f) {
    if (f.dataset.usfBusy) return;
    f.dataset.usfBlankForm = 'true';
    const selected = id(f), l = labels(f);
    const product=JSON.parse(entry(f).querySelector('[data-usf-policy-product]')?.textContent||'{}');
    const restricted=window.USFPrintlabPolicy?.(product,selected);
    const launch=entry(f).querySelector('[data-usf-open-pro]');
    if(launch){launch.disabled=!!restricted;launch.setAttribute('aria-disabled',String(!!restricted));}
    const hint=entry(f).querySelector('[data-usf-personalise-hint]');
    if(hint){hint.dataset.originalHint??=hint.textContent;hint.textContent=restricted?window.USFPrintlabCopy.variant:hint.dataset.originalHint;}
    if (!selected) return;
    if (f.dataset.usfResolved === selected) return;
    f.dataset.usfResolved = selected;
    paint(f, l.checking, true);
    try {
      const variant = await resolve(f, selected);
      if (id(f) !== selected || !f.isConnected) return;
      paint(f, l.blank + ' · ' + new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:entry(f).dataset.currency || 'GBP'}).format(variant.price / 100), false);
    } catch (_) {
      if (id(f) === selected) { paint(f, l.unavailable, true); }
    }
  }
  async function add(f) {
    if (f.dataset.usfBusy) return;
    const l = labels(f), selected = id(f);
    f.dataset.usfBusy = 'true'; paint(f, l.adding, true); status(f, '');
    try {
      const variant = await resolve(f, selected);
      if (id(f) !== selected) throw new Error('Selection changed. Please try again.');
      const quantityInput = f.querySelector('[name="quantity"]') || document.querySelector('input[name="quantity"][form="'+CSS.escape(f.id)+'"]');
      const quantity = Number(quantityInput?.value || 1);
      if (!Number.isInteger(quantity) || quantity < 1) throw new Error('Choose a valid quantity.');
      const response = await fetch(entry(f).dataset.cartAdd, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:variant.id,quantity}]})});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || l.error);
      location.assign(entry(f).dataset.cartUrl);
    } catch (error) { status(f, error.message || l.error); delete f.dataset.usfBusy; delete f.dataset.usfResolved; update(f); }
  }
  document.addEventListener('click', event => {
    const launch = event.target.closest('[data-usf-open-pro]');
    if (launch) {
      if(launch.disabled)return;
      const target = document.querySelector('#usf-custom-studio [data-action="open"]') || document.querySelector('[data-printlab-login]');
      if (target) target.click();
      else launch.closest('[data-usf-pro-entry]').querySelector('[data-usf-cart-status]').textContent = JSON.parse(launch.closest('[data-usf-pro-entry]').querySelector('[data-usf-cart-labels]').textContent).open_error;
      return;
    }
    const button = event.target.closest('button[type="submit"],input[type="submit"]');
    if (button?.form && entry(button.form) && !button.form.closest('#usf-custom-studio')) { event.preventDefault(); event.stopImmediatePropagation(); add(button.form); }
  }, true);
  document.addEventListener('submit', event => {
    if (event.target.matches('form[action*="/cart/add"]') && entry(event.target) && !event.target.closest('#usf-custom-studio')) { event.preventDefault(); event.stopImmediatePropagation(); add(event.target); }
  }, true);
  let timer;
  const refresh = () => { clearTimeout(timer); timer = setTimeout(() => forms().forEach(update), 120); };
  document.addEventListener('change', () => { forms().forEach(f => delete f.dataset.usfResolved); refresh(); });
  new MutationObserver(refresh).observe(document.body, {childList:true,subtree:true,attributes:true,attributeFilter:['value']});
  forms().forEach(update);
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const videos = new Set();
  const paintMotion = video => {
    const control = video.closest('[data-usf-pro-entry]')?.querySelector('[data-usf-video-toggle]');
    if (!control) return;
    control.textContent = video.paused ? '▶' : 'Ⅱ';
    control.setAttribute('aria-label', video.paused ? control.dataset.playLabel : control.dataset.pauseLabel);
  };
  const playVideo = video => {
    video.muted = true;
    video.defaultMuted = true;
    video.play().then(() => paintMotion(video)).catch(() => paintMotion(video));
  };
  const observer = new IntersectionObserver(entries => entries.forEach(({target,isIntersecting}) => {
    target.dataset.usfVisible = isIntersecting ? 'true' : 'false';
    if (isIntersecting && !document.hidden && !motion.matches && target.dataset.usfPaused !== 'true') playVideo(target);
    else target.pause();
  }), {threshold:0.15});
  const setupVideos = () => {
    for (const video of videos) if (!video.isConnected) { observer.unobserve(video); videos.delete(video); }
    document.querySelectorAll('.usf-pro-entry video').forEach(video => {
      if (videos.has(video)) return;
      videos.add(video);
      video.muted = true; video.defaultMuted = true;
      video.addEventListener('play', () => paintMotion(video));
      video.addEventListener('pause', () => paintMotion(video));
      if (motion.matches) { video.autoplay = false; video.pause(); }
      observer.observe(video); paintMotion(video);
    });
  };
  document.addEventListener('click', event => {
    const control = event.target.closest('[data-usf-video-toggle]');
    if (!control) return;
    const video = control.closest('[data-usf-pro-entry]').querySelector('video');
    if (video.paused) { video.dataset.usfPaused = 'false'; playVideo(video); }
    else { video.dataset.usfPaused = 'true'; video.pause(); }
  });
  const resumeVisible = () => videos.forEach(video => {
    if (!document.hidden && !motion.matches && video.dataset.usfVisible === 'true' && video.dataset.usfPaused !== 'true') playVideo(video);
    else video.pause();
  });
  document.addEventListener('visibilitychange', resumeVisible);
  document.addEventListener('touchstart', () => { if (!motion.matches) resumeVisible(); }, {once:true,passive:true});
  motion.addEventListener('change', resumeVisible);
  new MutationObserver(records => { if (records.some(r => [...r.addedNodes].some(n => n.nodeType === 1 && (n.matches?.('[data-usf-pro-entry],video') || n.querySelector?.('[data-usf-pro-entry]'))))) setupVideos(); }).observe(document.body,{childList:true,subtree:true});
  setupVideos();
})();
